import * as Yup from 'yup';

export const validationSchema = Yup.object({
    title: Yup.string().max(240).required('Поле обязательное для заполнения'),
    subTitle: Yup.string()
        .max(240)
        .required('Поле обязательное для заполнения'),
    name: Yup.string().max(240).required('Поле обязательное для заполнения'),
    startDate: Yup.date(),
    endDate: Yup.date(),
    issueCards: Yup.number(),
    template_id: Yup.string().required('Поле обязательное для заполнения'),
});
